var map = {
	"./dog_1.png": 8169,
	"./dog_3.png": 1115,
	"./dog_5.png": 6333,
	"./dog_7.png": 4111,
	"./dog_9.png": 1249,
	"./dog_activity_11.png": 7656,
	"./dog_activity_12.png": 9619,
	"./dog_activity_13.png": 7706,
	"./dog_activity_14.png": 8133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6431;